/**
 * La garde d'accès commune aux douze features du back-office.
 *
 * @remarks
 * Un seul endroit pour la liste des rôles : elle est déclarée douze fois dans
 * les manifests via `enabledWhen`, ce qui est déjà une répétition de trop —
 * inutile d'en ajouter une par groupe de routes.
 *
 * `enabledWhen: { roles: ['admin'] }` et cette garde ne font pas le même
 * travail et ne sont pas redondants :
 *
 * - `enabledWhen` décide de ce qui **s'affiche** — vue centrale, onglets, lien
 *   de navigation. Il ne protège rien : `createRouter()` monte les routes de
 *   toutes les features enregistrées, sans le consulter.
 * - `guard` décide de ce qui est **atteignable**. C'est lui qui répond à une
 *   URL tapée à la main.
 *
 * Avant SAAS-883, seul le premier existait : un utilisateur sans le rôle
 * atteignait `/admin/users`, et le contexte tombait sur le placeholder de
 * développement « Pas encore de feature pour ce contexte » suivi de son nom
 * technique. Aucune donnée ne fuitait — les vues sont derrière le registry —
 * mais l'écran était un cul-de-sac écrit pour les développeurs.
 */

import { requireRole } from '@/app/router/guards/require-role';

export const ADMIN_GUARD = requireRole(['admin']);
